









import Vue from 'vue';
import AppModule from '../../common/components/AppModule.vue';
import { AppModuleConfig, AppModuleNavItem } from '../../common/models/AppModuleConfig';
import massVuex from '../vuex/common';
import appClient from '../../apis';
import ModuleUpgrade from '../../common/components/ModuleUpgrade.vue';
import customerClient from '../../customer/apis';

const moduleNavs: AppModuleNavItem[] = [
  { name: '公众号高级群发', alias: 'mpgroup' },
  { name: '模板消息群发', alias: 'wxtpl' },
  { name: '广播群发', alias: 'broadcast' },
  { name: '订阅群发', alias: 'subscribe' },
  { name: '管理员', alias: 'admin' },
  { name: '群发记录', alias: 'records' },
];

const module: AppModuleConfig = {
  module: 'mass',
  name: '客户群发',
  navs: moduleNavs,
  description: undefined,
};

export default Vue.extend({
  mixins: [massVuex],
  components: {
    AppModule,
    ModuleUpgrade,
  },
  data() {
    return {
      module,
      hasRights: true,
    };
  },
  watch: {
    'account'() {
      this.setModule();
    },
  },
  methods: {
    getRights() {
      appClient.hasRights({module: 'mass'}).success((r) => {
        this.hasRights = r;
      });
    },
    setModule() {
      if (this.account.weixinType !== 1) {
        const moduleNavs: AppModuleNavItem[] = [
          { name: '公众号群发', alias: 'mpgroup' },
          { name: '广播群发', alias: 'broadcast' },
          { name: '管理员', alias: 'admin' },
          { name: '群发记录', alias: 'records' },
        ];
        this.module = {
          module: 'mass',
          name: '客户群发',
          navs: moduleNavs,
          description: undefined,
        };
      } else {
        this.module = {
          module: 'mass',
          name: '客户群发',
          navs: moduleNavs,
          description: undefined,
        };
      }
    },
  },
  mounted() {
    this.getRights();
    if (this.account.weixinType !== 1) {
      this.setModule();
    }
    customerClient.getProps().success((r) => {
      this.$store.commit('SET_CUSTOMER_PROPS', r.props);
    });
  },
});
